const english = {
  pageTitle: "Payment Method",
  sl: "SL",
  name: "Name",
  action: "Action",
  paymentMethod: "Payment Method",
  addPaymentMethod: "Add Payment Method",
  editPaymentMethod: "Edit Payment Method",
  editPaymentMethodForm: "Edit Payment Method Form",
  addPaymentMethodForm: "Add Payment Method Form",
  warning: "Are you sure?",
  yes: "Yes Delete It!",
  youWontRevertIt: "You won't be able to revert this!",
  cancel: "Cancel",
  delete: "Delete",
  submit: "Submit",
  save: "Save",
};
const thai = {
  pageTitle: "วิธีการชำระเงิน",
  sl: "ลำดับ",
  name: "ชื่อ",
  action: "การกระทำ",
  paymentMethod: "วิธีการชำระเงิน",
  addPaymentMethod: "เพิ่มวิธีการชำระเงิน",
  editPaymentMethod: "แก้ไขวิธีการชำระเงิน",
  editPaymentMethodForm: "แบบฟอร์มแก้ไขวิธีการชำระเงิน",
  addPaymentMethodForm: "แบบฟอร์มเพิ่มวิธีการชำระเงิน",
  warning: "คุณแน่ใจหรือไม่?",
  yes: "ใช่ ลบออก!",
  youWontRevertIt: "คุณจะไม่สามารถย้อนกลับได้!",
  cancel: "ยกเลิก",
  delete: "ลบ",
  submit: "ส่ง",
  save: "บันทึก",
};
const malay = {
  pageTitle: "Kaedah Pembayaran",
  sl: "SL",
  name: "Nama",
  action: "Tindakan",
  paymentMethod: "Kaedah Pembayaran",
  addPaymentMethod: "Tambah Kaedah Pembayaran",
  editPaymentMethod: "Edit Kaedah Pembayaran",
  editPaymentMethodForm: "Borang Edit Kaedah Pembayaran",
  addPaymentMethodForm: "Borang Tambah Kaedah Pembayaran",
  warning: "Adakah anda pasti?",
  yes: "Ya, Padamkannya!",
  youWontRevertIt: "Anda tidak akan dapat mengembalikannya!",
  cancel: "Batal",
  delete: "Padam",
  submit: "Hantar",
  save: "Simpan",
};
const arabic = {
  pageTitle: "طريقة الدفع",
  sl: "التسلسل",
  name: "الاسم",
  action: "الإجراء",
  paymentMethod: "طريقة الدفع",
  addPaymentMethod: "إضافة طريقة دفع",
  editPaymentMethod: "تعديل طريقة الدفع",
  editPaymentMethodForm: "نموذج تعديل طريقة الدفع",
  addPaymentMethodForm: "نموذج إضافة طريقة الدفع",
  warning: "هل أنت متأكد؟",
  yes: "نعم، احذفه!",
  youWontRevertIt: "لن تتمكن من التراجع عن هذا!",
  cancel: "إلغاء",
  delete: "حذف",
  submit: "إرسال",
  save: "حفظ",
};
const bengali = {
  pageTitle: "পেমেন্ট পদ্ধতি",
  sl: "ক্রম",
  name: "নাম",
  action: "ক্রিয়া",
  paymentMethod: "পেমেন্ট পদ্ধতি",
  addPaymentMethod: "পেমেন্ট পদ্ধতি যোগ করুন",
  editPaymentMethod: "পেমেন্ট পদ্ধতি সম্পাদনা করুন",
  editPaymentMethodForm: "পেমেন্ট পদ্ধতি সম্পাদনার ফর্ম",
  addPaymentMethodForm: "পেমেন্ট পদ্ধতি যোগ করার ফর্ম",
  warning: "আপনি কি নিশ্চিত?",
  yes: "হ্যাঁ, মুছে ফেলুন!",
  youWontRevertIt: "আপনি এটি পুনরুদ্ধার করতে পারবেন না!",
  cancel: "বাতিল",
  delete: "মুছুন",
  submit: "জমা দিন",
  save: "সংরক্ষণ করুন",
};

export const paymentMethodLang = {
  english,
  malay,
  thai,
  arabic,
  bengali,
};
